/*
 * SectionNavigationTab Specification
 * @module SectionNavigation
 * @flow
 */

import { compose, pure, withHandlers } from 'recompose';

import { withDevice } from '~/features/App/Device';
import { findRouteIndexByPathname, matchRouteByPathname } from '~/helpers';

import { SectionNavigationTab as SNT } from './SectionNavigationTab';

const enhance = compose(
  withDevice,
  withHandlers({
    checkIsActive: ({ tabs }) => (match, { pathname }) =>
      tabs
        ? findRouteIndexByPathname(pathname, tabs) !== -1
        : match
        ? matchRouteByPathname(pathname, match.path)
        : false,
  }),
  pure,
);

export const SectionNavigationTab = enhance(SNT);
